import React from 'react'
import injectSheet from 'react-jss'
import styles from './my-files-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import CircleStatus from 'pobble-components/dist/circle-status'
import { Link } from 'react-router-dom'
import ContextMenu from './context-menu/context-menu.container'
import AgeGroup from 'pobble-components/dist/age-group'
import Tooltip from 'pobble-components/dist/tooltip'
import classNames from 'classnames'

const MyFilesEntry = ({
  classes,
  id,
  title,
  conclusion,
  createdAt,
  pending,
  link,
  students,
  thumb,
  ageGroupTitle,
  ageGroupOrder,
  moderationType,
  judgement,
  judgementShort
}) => (
  <TableRow pending={pending}>
    <Cell className={classes.thumbnail}>
      <Link to={link}>
        <span style={{ backgroundImage: `url("${thumb}")` }} />
      </Link>
    </Cell>
    <Cell className={classes.date}>{createdAt}</Cell>
    <Cell>
      <Link className={classes.link} to={link}>
        {title}
      </Link>
    </Cell>
    <Cell>{students}</Cell>
    <Cell>
      <AgeGroup order={ageGroupOrder}>{ageGroupTitle}</AgeGroup>
    </Cell>
    <Cell className={classNames(classes.center, classes.initials)}>
      {moderationType && (
        <Tooltip content={moderationType}>
          {moderationType.split(' ').map(w => w[0])}
        </Tooltip>
      )}
      {!moderationType && '-'}
    </Cell>
    <Cell className={classNames(classes.center, classes.initials)}>
      {judgement && <Tooltip content={judgement}>{judgementShort}</Tooltip>}
      {!judgement && '-'}
    </Cell>
    <Cell className={classes.center}>
      <CircleStatus status={conclusion} />
    </Cell>
    <Cell right>
      <ContextMenu id={id} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(MyFilesEntry)
